var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "111px",
    height: "48px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.803
    },
    fill: "#f887e6",
    d: "M 46.5,12.5 C 45.6618,12.8417 45.3284,13.5084 45.5,14.5C 45.1667,15.1667 44.8333,15.8333 44.5,16.5C 43.5987,17.2905 42.9321,18.2905 42.5,19.5C 41.5416,19.0472 40.7083,18.3805 40,17.5C 39.1558,19.4628 39.6558,20.7961 41.5,21.5C 41.6716,22.4916 41.3382,23.1583 40.5,23.5C 33.3592,22.8683 26.3592,22.8683 19.5,23.5C 19.5,21.8333 19.5,20.1667 19.5,18.5C 18.5,18.5 17.5,18.5 16.5,18.5C 16.5,20.1667 16.5,21.8333 16.5,23.5C 14.549,23.7733 13.049,23.1066 12,21.5C 9.87885,23.4574 7.37885,23.9574 4.5,23C 3.33333,22.5 2.5,21.6667 2,20.5C -0.993959,11.3525 2.17271,7.01913 11.5,7.5C 11.5,8.5 11.5,9.5 11.5,10.5C 13.1439,10.7135 14.6439,10.3802 16,9.5C 16.4935,11.1341 16.6602,12.8008 16.5,14.5C 17.5,14.5 18.5,14.5 19.5,14.5C 19.5,12.8333 19.5,11.1667 19.5,9.5C 23.8461,9.33432 28.1794,9.50098 32.5,10C 33.8741,13.4101 34.5408,13.2434 34.5,9.5C 36.1667,9.5 37.8333,9.5 39.5,9.5C 39.3505,10.552 39.5172,11.552 40,12.5C 41.7342,10.5494 43.9009,9.54937 46.5,9.5C 46.5,10.5 46.5,11.5 46.5,12.5 Z M 10.5,11.5 C 11.7251,12.1522 12.3917,13.3189 12.5,15C 12.3333,16.1667 12.1667,17.3333 12,18.5C 11.6667,18.1667 11.3333,17.8333 11,17.5C 9.92071,19.3937 8.58738,19.727 7,18.5C 6.50454,16.5273 6.33788,14.5273 6.5,12.5C 8.09903,12.7678 9.43236,12.4345 10.5,11.5 Z M 34.5,15.5 C 35.7122,17.2637 35.3788,18.9303 33.5,20.5C 32.3482,18.6029 32.6815,16.9362 34.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.838
    },
    fill: "#b864d2",
    d: "M 59.5,7.5 C 60.1667,7.5 60.8333,7.5 61.5,7.5C 60.5592,9.04953 59.8925,10.7162 59.5,12.5C 58.6618,12.1583 58.3284,11.4916 58.5,10.5C 59.1098,9.60895 59.4431,8.60895 59.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.917
    },
    fill: "#b161d0",
    d: "M 61.5,7.5 C 62.1667,7.5 62.5,7.83333 62.5,8.5C 61.7368,10.3684 60.7368,12.0351 59.5,13.5C 59.5,13.1667 59.5,12.8333 59.5,12.5C 59.8925,10.7162 60.5592,9.04953 61.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.74
    },
    fill: "#a55acc",
    d: "M 65.5,7.5 C 64.3517,11.7868 62.685,15.7868 60.5,19.5C 60.5,17.8333 60.5,16.1667 60.5,14.5C 61.7368,13.0351 62.7368,11.3684 63.5,9.5C 64.1667,8.83333 64.8333,8.16667 65.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.817
    },
    fill: "#9f57cb",
    d: "M 65.5,7.5 C 67.7812,7.07729 69.4479,7.74395 70.5,9.5C 67.0736,13.4647 65.7402,18.1314 66.5,23.5C 64.5,23.5 62.5,23.5 60.5,23.5C 60.5,22.1667 60.5,20.8333 60.5,19.5C 62.685,15.7868 64.3517,11.7868 65.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.575
    },
    fill: "#ec80e3",
    d: "M 50.5,9.5 C 49.5592,11.0495 48.8925,12.7162 48.5,14.5C 47.5,14.5 46.5,14.5 45.5,14.5C 45.3284,13.5084 45.6618,12.8417 46.5,12.5C 47.404,11.791 47.7373,10.791 47.5,9.5C 48.5,9.5 49.5,9.5 50.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.819
    },
    fill: "#c96ed8",
    d: "M 54.5,9.5 C 55.1667,9.5 55.8333,9.5 56.5,9.5C 56.5,10.1667 56.5,10.8333 56.5,11.5C 56.5,12.5 56.5,13.5 56.5,14.5C 55.5,14.5 54.5,14.5 53.5,14.5C 54.038,12.8828 54.3713,11.2161 54.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    fill: "#c26ad5",
    d: "M 59.5,7.5 C 59.4431,8.60895 59.1098,9.60895 58.5,10.5C 57.8333,10.8333 57.1667,11.1667 56.5,11.5C 56.5,10.8333 56.5,10.1667 56.5,9.5C 57.7383,9.18999 57.7383,8.68999 56.5,8C 57.448,7.51722 58.448,7.35055 59.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.776
    },
    fill: "#9e57cb",
    d: "M 70.5,9.5 C 72.1439,9.28649 73.6439,9.61983 75,10.5C 75.3333,13.5 75.6667,16.5 76,19.5C 76.4983,16.1832 76.665,12.8499 76.5,9.5C 80.8461,9.33432 85.1794,9.50098 89.5,10C 90.6667,10.5 91.5,11.3333 92,12.5C 93.9941,22.0041 90.1607,25.6707 80.5,23.5C 77.5,23.1667 74.5,22.8333 71.5,22.5C 70.5614,18.2351 70.2281,13.9017 70.5,9.5 Z M 86.5,13.5 C 88.8549,15.2462 89.0216,17.2462 87,19.5C 86.5045,17.5273 86.3379,15.5273 86.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.809
    },
    fill: "#9e57cb",
    d: "M 95.5,9.5 C 97.8333,9.5 100.167,9.5 102.5,9.5C 103.026,13.936 104.026,18.2693 105.5,22.5C 103.164,23.7123 100.997,23.379 99,21.5C 97.0027,23.379 94.836,23.7123 92.5,22.5C 94.2896,18.3421 95.2896,14.0088 95.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e37ce0",
    d: "M 50.5,9.5 C 50.8333,9.5 51.1667,9.5 51.5,9.5C 51.1075,11.2838 50.4408,12.9505 49.5,14.5C 49.1667,14.5 48.8333,14.5 48.5,14.5C 48.8925,12.7162 49.5592,11.0495 50.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.756
    },
    fill: "#dd78de",
    d: "M 51.5,9.5 C 52.1667,9.5 52.8333,9.5 53.5,9.5C 52.4043,12.0316 51.0709,14.3649 49.5,16.5C 49.5,15.8333 49.5,15.1667 49.5,14.5C 50.4408,12.9505 51.1075,11.2838 51.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ab5ece",
    d: "M 62.5,8.5 C 63.1667,8.5 63.5,8.83333 63.5,9.5C 62.7368,11.3684 61.7368,13.0351 60.5,14.5C 59.8333,14.5 59.5,14.1667 59.5,13.5C 60.7368,12.0351 61.7368,10.3684 62.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d373db",
    d: "M 53.5,9.5 C 53.8333,9.5 54.1667,9.5 54.5,9.5C 54.3713,11.2161 54.038,12.8828 53.5,14.5C 52.1667,16.8333 50.8333,19.1667 49.5,21.5C 49.5,19.8333 49.5,18.1667 49.5,16.5C 51.0709,14.3649 52.4043,12.0316 53.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.833
    },
    fill: "#ea7fe2",
    d: "M 45.5,17.5 C 46.3382,17.8417 46.6716,18.5084 46.5,19.5C 45.3263,20.5137 44.6596,21.847 44.5,23.5C 43.8333,23.8333 43.1667,24.1667 42.5,24.5C 43.2271,22.0462 44.2271,19.7128 45.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.933
    },
    fill: "#cb6fd8",
    d: "M 53.5,14.5 C 53.5,15.5 53.5,16.5 53.5,17.5C 52.2616,19.2143 51.595,21.2143 51.5,23.5C 50.1667,23.5 49.5,22.8333 49.5,21.5C 50.8333,19.1667 52.1667,16.8333 53.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.967
    },
    fill: "#f083e4",
    d: "M 44.5,16.5 C 45.1667,16.5 45.5,16.8333 45.5,17.5C 44.2271,19.7128 43.2271,22.0462 42.5,24.5C 41.5084,24.6716 40.8417,24.3382 40.5,23.5C 41.3382,23.1583 41.6716,22.4916 41.5,21.5C 41.8333,20.8333 42.1667,20.1667 42.5,19.5C 42.9321,18.2905 43.5987,17.2905 44.5,16.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c26ad5",
    d: "M 53.5,17.5 C 53.5,18.1667 53.5,18.8333 53.5,19.5C 53.5674,20.9587 53.2341,22.2921 52.5,23.5C 52.1667,23.5 51.8333,23.5 51.5,23.5C 51.595,21.2143 52.2616,19.2143 53.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.356
    },
    fill: "#ba66d3",
    d: "M 53.5,19.5 C 54.1239,19.9169 54.4573,20.5836 54.5,21.5C 54.2528,22.7133 53.5862,23.38 52.5,23.5C 53.2341,22.2921 53.5674,20.9587 53.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.567
    },
    fill: "#e47ce0",
    d: "M 46.5,19.5 C 46.7709,21.3797 46.1042,22.713 44.5,23.5C 44.6596,21.847 45.3263,20.5137 46.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f72dff",
    d: "M 2.5,28.5 C 37.6643,27.3357 72.9976,27.169 108.5,28C 73.1682,28.5 37.8349,28.6667 2.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.378
    },
    fill: "#fefffe",
    d: "M 19.5,31.5 C 20.7733,32.0768 20.7733,32.7435 19.5,33.5C 18.537,33.0302 18.537,32.3635 19.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.378
    },
    fill: "#fefffe",
    d: "M 28.5,31.5 C 29.2891,31.7828 29.9558,32.2828 30.5,33C 29.184,33.5281 28.5173,33.0281 28.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.627
    },
    fill: "#fefffe",
    d: "M 4.5,32.5 C 7.01147,32.838 9.3448,32.838 11.5,32.5C 12.5195,33.6872 13.6861,34.6872 15,35.5C 17,34.1667 19,34.1667 21,35.5C 23.0363,34.898 24.8697,33.898 26.5,32.5C 27.8066,33.8155 29.3066,34.8155 31,35.5C 34.3936,34.5442 37.8936,34.2108 41.5,34.5C 41.2912,40.2611 40.4578,40.5945 39,35.5C 38.51,36.7932 38.3433,38.1266 38.5,39.5C 35.319,39.2577 32.319,39.2577 29.5,39.5C 28.7189,38.2713 28.2189,36.938 28,35.5C 27.7811,36.938 27.2811,38.2713 26.5,39.5C 24.0134,39.2176 21.3467,39.2176 18.5,39.5C 18.1667,34.1667 17.8333,34.1667 17.5,39.5C 16.1667,39.5 14.8333,39.5 13.5,39.5C 13.4427,34.3183 12.776,34.3183 11.5,39.5C 9.32843,39.3241 6.9951,39.1575 4.5,39C 2.06886,36.8938 2.06886,34.7272 4.5,32.5 Z M 6.5,33.5 C 7.70792,34.2341 9.04125,34.5674 10.5,34.5C 9.4132,38.8815 7.4132,39.3815 4.5,36C 5.05558,34.9889 5.72225,34.1556 6.5,33.5 Z M 32.5,35.5 C 34.4646,35.9483 34.7979,36.9483 33.5,38.5C 32.6143,37.675 32.281,36.675 32.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.677
    },
    fill: "#fefffe",
    d: "M 43.5,33.5 C 44.9097,32.1716 46.0764,32.5049 47,34.5C 47.8373,32.9926 49.0039,32.4926 50.5,33C 50.1667,33.3333 49.8333,33.6667 49.5,34C 50.9675,35.0975 51.8008,36.5975 52,38.5C 52.2189,37.062 52.7189,35.7287 53.5,34.5C 55.7638,35.3036 57.7638,34.6369 59.5,32.5C 60.2508,33.376 60.7508,34.376 61,35.5C 62.6995,34.5939 64.5328,34.2606 66.5,34.5C 66.5,36.1667 66.5,37.8333 66.5,39.5C 61.6984,39.154 56.8651,39.154 52,39.5C 50.1183,38.9067 49.1183,37.5733 49,35.5C 48.7811,36.938 48.2811,38.2713 47.5,39.5C 47.0248,36.8453 45.6915,34.8453 43.5,33.5 Z M 56.5,35.5 C 58.4646,35.9483 58.7979,36.9483 57.5,38.5C 56.6143,37.675 56.281,36.675 56.5,35.5 Z M 62.5,35.5 C 64.4646,35.9483 64.7979,36.9483 63.5,38.5C 62.6143,37.675 62.281,36.675 62.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.648
    },
    fill: "#fefffe",
    d: "M 78.5,35.5 C 77.1653,40.5354 75.9987,40.5354 75,35.5C 73.9887,36.3366 72.8221,36.67 71.5,36.5C 71.719,37.675 71.3857,38.675 70.5,39.5C 69.5258,37.2573 69.1924,34.924 69.5,32.5C 73.0774,32.1449 76.0774,33.1449 78.5,35.5 Z M 71.5,33.5 C 73.337,33.6395 73.6704,34.3061 72.5,35.5C 71.7025,35.0431 71.3691,34.3764 71.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.671
    },
    fill: "#fefffe",
    d: "M 78.5,35.5 C 81.3813,35.0948 84.048,34.0948 86.5,32.5C 91.5238,34.0999 96.6905,35.0999 102,35.5C 103.699,34.5939 105.533,34.2606 107.5,34.5C 107.5,36.1667 107.5,37.8333 107.5,39.5C 104.989,39.162 102.655,39.162 100.5,39.5C 99.7189,38.2713 99.2189,36.938 99,35.5C 98,40.8333 97,40.8333 96,35.5C 95.51,36.7932 95.3433,38.1266 95.5,39.5C 92.319,39.2577 89.319,39.2577 86.5,39.5C 85.224,34.3183 84.5573,34.3183 84.5,39.5C 80.7593,40.4015 78.7593,39.0681 78.5,35.5 Z M 80.5,35.5 C 82.7602,36.2376 82.9269,37.2376 81,38.5C 80.5172,37.552 80.3505,36.552 80.5,35.5 Z M 89.5,35.5 C 91.4646,35.9483 91.7979,36.9483 90.5,38.5C 89.6143,37.675 89.281,36.675 89.5,35.5 Z M 103.5,35.5 C 105.465,35.9483 105.798,36.9483 104.5,38.5C 103.614,37.675 103.281,36.675 103.5,35.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.eecac2b83ad6e304cc044348df065eb3.svg";
export { ForwardRef as ReactComponent };